'use client';


import { getColorModeFromColorTheme } from "../utils/color-theme.js";
import { useColorTheme } from "./ColorThemeProvider.js";
import { useColorMode } from "@chakra-ui/react";
import { c } from "react-compiler-runtime";
import { useEffect } from "react";

//#region src/providers/ThemeColorModeSync.tsx
const ThemeColorModeSync = (t0) => {
	const $ = c(4);
	const { children } = t0;
	const { setColorMode } = useColorMode();
	const { colorTheme } = useColorTheme();
	let t1;
	let t2;
	if ($[0] !== colorTheme || $[1] !== setColorMode) {
		t1 = () => {
			setColorMode(getColorModeFromColorTheme(colorTheme));
		};
		t2 = [colorTheme, setColorMode];
		$[0] = colorTheme;
		$[1] = setColorMode;
		$[2] = t1;
		$[3] = t2;
	} else {
		t1 = $[2];
		t2 = $[3];
	}
	useEffect(t1, t2);
	return children;
};

//#endregion
export { ThemeColorModeSync };
//# sourceMappingURL=ThemeColorModeSync.js.map